var React = require('react');

function Recent (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M15.26 13.595H13a1 1 0 0 1-1-1V9.53a.53.53 0 1 1 1.061 0v3.004h2.199a.53.53 0 0 1 0 1.06zM12.51 6A6.5 6.5 0 0 0 6 12.543c.006 3.545 2.936 6.46 6.49 6.457 3.635-.003 6.517-2.923 6.51-6.596-.006-3.495-2.964-6.413-6.49-6.404z"}));
}

Recent.defaultProps = {"width":"25","height":"25"};

module.exports = Recent;

Recent.default = Recent;
